import { SORT } from "../../constants";

export const sortBy = key => {
  return {
    type: SORT,
    key
  };
};



// WEBPACK FOOTER //
// ./src/js/actions/actions.js